import { CreatorRegistrationDataService, type RegistrationDataDto } from '@api'
import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router'

import { $account } from '@/models/account.ts'
import { SegmentEvents, analytics } from '@/utils/analytics'
import { AppRoutes } from '@/utils/constants'
import { handleError } from '@/utils/error'

import { referralOptions } from '../consts'
import type { QuestionnaireFormValues } from '../types'
import { transformQuestionnaireFormToRequestOptions } from '../utils'

export const useQuestionnaireSubmit = () => {
  const account = useUnit($account)
  const navigate = useNavigate()

  const submitQuestionnaireMutation = useMutation(
    async (values: QuestionnaireFormValues) =>
      CreatorRegistrationDataService.create({
        requestBody: transformQuestionnaireFormToRequestOptions(values),
      }),
    {
      onSuccess(_, values) {
        const referralLabel =
          referralOptions.find((option) => option.value === values.referral)
            ?.label || values.referral

        analytics.track(SegmentEvents.SurveyFilled, {
          type: values.businessType,
          contactType: values.preferredCommunication,
          contact: values.Telegram || values.WhatsApp,
          email: values.Email || account?.email,
          referral: referralLabel,
          referralInfo:
            values.influencer ||
            values.socialMedia ||
            values.blog ||
            values.other,
        })
        navigate(AppRoutes.Overview.asUrl())
      },
      onError(error) {
        handleError(error, 'Failed to submit questionnaire. Please try again.')
      },
    },
  )

  return submitQuestionnaireMutation.mutateAsync as (
    values: QuestionnaireFormValues,
  ) => Promise<RegistrationDataDto>
}
